<template>
    <x-container app-width fluid grid-list-lg>
        <modal
            action-text="Ok"
            ref="unauthorisedModalView"
            title="Unauthorised"
        >
            <x-layout mt-4>
                <x-flex>
                    <p>You do not have the required permissions to perform this action.</p>
                </x-flex>
            </x-layout>
        </modal>
    </x-container>
</template>
<script>
    import Modal from '~/components/Shared/UIComponents/Modal';

    export default {
        name: 'UnauthorisedModal',
        components: {
            Modal,
        },
        mounted() {
            this.openModal();
        },
        methods: {
            async openModal() {
                await this.$refs.unauthorisedModalView.open();
                this.$eventBus.$emit('unauthorised', false);
            },
        }
    }
</script>

<style lang="scss">
    .right-border {
        border-right: 1px solid;
    }

    .base-timer {
        position: relative;
        width: 100%;
        height: 100px;

        display: flex;
        align-items: center;
        justify-content: center;

        &__label {
            top: 0;
            font-size: 30px;
            width: 80px;
            text-align: left;

            &.green-color {
                color: $color-green
            }

            &.orange-color {
                color: $color-orange;
            }

            &.red-color {
                color: $color-red;
            }
        }
    }
</style>
